import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useDebounce } from '../../hooks/useDebounce';
import useGetEmails from '../../hooks/useGetEmails';
import { AutoComplete } from '../Autocomplete/AutoComplete';
export const EmailAutocomplete = ({ placeholder, selectedValue, recipient, onSelectedValueChange, }) => {
    const [searchValue, setSearchValue] = useState('');
    const debouncedSearchValue = useDebounce(searchValue, 500);
    const { data, isLoading } = useGetEmails(debouncedSearchValue, recipient);
    return (_jsx(AutoComplete, { selectedValue: selectedValue, onSelectedValueChange: onSelectedValueChange, searchValue: searchValue, onSearchValueChange: setSearchValue, items: data ?? [], isLoading: isLoading, emptyMessage: "No results found.", placeholder: placeholder }));
};
